var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.formLoading)?_c('div',{},[_c('ResponsiveFieldsForm',{ref:"restForm",attrs:{"defaultItem":_vm.defaultItem,"editObj":_vm.formObj,"getRestData":_vm.getRestData,"formFields":_vm.restFields}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }